// extracted by mini-css-extract-plugin
export default {"tableContainer":"list_tableContainer__30UHs","table":"list_table__27EDz","subText":"list_subText__oQ0D-"};